module.exports = __webpack_public_path__ + "img/appellation.1ba86191.jpg";